import { AdditionalInfoDataTypes } from "us.common/constants";

export function SaveInformation(this: any): any {
  return {
    itemId: this.recordId,
    fieldId: this.metaData[0].id,
    entityId: this.entityId,
    fieldName: this.informationItem.key,
    dataTypeId: this.metaData[0].dataTypeId,
    valueType: this.metaData[0].valueType,
    displayName: this.informationItem.key,
    value:
      this.metaData[0].dataType === AdditionalInfoDataTypes.DATE_TIME
        ? this.informationItem.value.format("DD/MM/YYYY")
        : this.informationItem.value,
  };
}
